import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpService } from './http.service';

interface IAutocompleteResponse {
  resultados: string[];
}

@Injectable({
  providedIn: 'root',
})
export class PlacePredictionService {
  constructor(private http: HttpService) {}

  public async getPlacePredictions(input: string): Promise<string[]> {
    if (!input) return [];
    try {
      const resp = await firstValueFrom(
        this.http.post('/geocode-cache/autocomplete', {
          text: input,
          pais: 'ar',
        }),
      );
      return (resp as IAutocompleteResponse)?.resultados || [];
    } catch (err) {
      console.error('Error en autocomplete de direcciones', err);
      return [];
    }
  }
}
